import React, { useEffect, useState } from "react"
import secureLocalStorage from "react-secure-storage"
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import Swal from "sweetalert2"
import { FetchPutData } from "utils/Common_api_functions"

const ProfileModal = ({ open, toggle, selectedStaff, setSelectedStaff }) => {
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setErrors({})
  }, [selectedStaff])

  const handleChange = (field, value) => {
    setSelectedStaff(prev => ({ ...prev, [field]: value }))
    setErrors(prev => ({ ...prev, [field]: "" }))
  }

  const allowOnlyNumbers = e => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "")
  }

  const validate = () => {
    const newErrors = {}

    if (!selectedStaff?.email?.trim()) {
      newErrors.email = "Email is required"
    }

    if (selectedStaff?.phone && selectedStaff.phone.length !== 10) {
      newErrors.phone = "Phone number must be 10 digits"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (!validate()) return

    try {
      const payload = { ...selectedStaff }

      if (!payload.password) {
        delete payload.password
      }

      const APIdata = await FetchPutData(
        setLoading,
        "users",
        selectedStaff?.id,
        payload
      )

      if (APIdata?.data?.success) {
        secureLocalStorage?.setItem("admin_user", APIdata?.data?.data)
        Swal.fire({
          title: "Profile Updated Successfully",
          text: APIdata?.data?.message,
          icon: "success",
        })

        toggle()
      }
    } catch (error) {
      console.log(error)

      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      })
    }
  }

  const renderError = field =>
    errors[field] && (
      <div className="invalid-feedback d-block">{errors[field]}</div>
    )

  const invalid = field => (errors[field] ? "is-invalid" : "")

  return (
    <Modal isOpen={open} centered toggle={toggle}>
      <ModalHeader toggle={toggle}>Update Profile</ModalHeader>

      <ModalBody>
        <Form>
          <Row>
            {/* Name */}
            <Col md={12}>
              <FormGroup>
                <Label>Name</Label>
                <Input
                  value={selectedStaff?.name || ""}
                  disabled
                  className="form-control rounded-4"
                />
              </FormGroup>
            </Col>

            {/* Email */}
            <Col md={12}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={selectedStaff?.email || ""}
                  onChange={e => handleChange("email", e.target.value)}
                  placeholder="Enter email"
                  className={`form-control rounded-4 ${invalid("email")}`}
                />
                {renderError("email")}
              </FormGroup>
            </Col>

            {/* Phone */}
            <Col md={12}>
              <FormGroup>
                <Label>Phone Number</Label>
                <Input
                  value={selectedStaff?.phone || ""}
                  maxLength={10}
                  onChange={e => {
                    allowOnlyNumbers(e)
                    handleChange("phone", e.target.value)
                  }}
                  placeholder="Enter phone number"
                  className={`form-control rounded-4 ${invalid("phone")}`}
                />
                {renderError("phone")}
              </FormGroup>
            </Col>

            {/* Password */}
            <Col md={12}>
              <FormGroup>
                <Label>New Password</Label>
                <Input
                  type="password"
                  onChange={e => handleChange("password", e.target.value)}
                  placeholder="Enter new password"
                  className="form-control rounded-4"
                />
                <small className="text-muted">
                  Leave blank if you don't want to change password
                </small>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button className="btn-blue" onClick={handleSubmit} disabled={loading}>
          {loading ? "Updating..." : "Update Profile"}
        </Button>

        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ProfileModal
